import { Col, DatePicker, Divider, Form, Input, Modal, Radio, Row, Select, Typography } from "antd";
import dayjs from "dayjs";
import PropTypes from 'prop-types';
import { useEffect, useState } from "react";
import { conducteurQualiteOptions, OPTIONS } from "./utils";
import { EditOutlined } from "@ant-design/icons";

export const EditModal = ({ visible, onCancel, sinistre, onSave, loading }) => {
    const [formData, setFormData] = useState({});
    const [form] = Form.useForm();


    useEffect(() => {
        if (sinistre) {
            setFormData({
                dateSinistre: sinistre.dateSinistre,
                lieu: sinistre.lieu || '',
                circonstance: sinistre.circonstance || '',
                provenanceAssure: sinistre.provenanceAssure || '',
                destinationAssure: sinistre.destinationAssure || '',
                vitesseAssure: sinistre.vitesseAssure || '',
                observationAgent: sinistre.observationAgent || '',
                typeDommageAssure: sinistre.typeDommageAssure || null,
                temoignage: sinistre.temoin ? 'oui' : 'non',
                conduisait: sinistre.conducteur ? 'non' : 'oui'
            });

            form.setFieldsValue({
                dateSinistre: sinistre.dateSinistre ? dayjs(sinistre.dateSinistre) : null,
                lieu: sinistre.lieu || '',
                circonstance: sinistre.circonstance || '',
                provenanceAssure: sinistre.provenanceAssure || '',
                destinationAssure: sinistre.destinationAssure || '',
                vitesseAssure: sinistre.vitesseAssure || '',
                observationAgent: sinistre.observationAgent || '',
                typeDommageAssure: sinistre.typeDommageAssure || null,
                temoignage: sinistre.temoin ? 'oui' : 'non',
                conduisait: sinistre.conducteur ? 'non' : 'oui'
            });
        }
    }, [sinistre, form]);

    return (
        <Modal
            title={
                <Typography.Text strong style={{ fontSize: 18 }}>
                    <EditOutlined /> Modifier les informations du sinistre
                </Typography.Text>
            }
            open={visible}
            onCancel={onCancel}
            confirmLoading={loading}
            onOk={() => onSave(formData)}
            okText="Enregistrer"
            cancelText="Annuler"
            width={1000}
            style={{ top: 20 }}
        >
            <Form
                layout="vertical"
                form={form}
                initialValues={{ temoignage: 'non', conduisait: 'oui' }}
            >
                <Divider orientation="left">Informations sur l'accident</Divider>

                <Row gutter={16}>
                    <Col xs={24} md={12} lg={8}>
                        <Form.Item
                            name="dateSinistre"
                            label="Date de survenance"
                            rules={[{ required: true, message: 'Sélectionnez la date du sinistre' }]}
                        >
                            <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                        <Form.Item name="lieu" label="Lieu de survenance">
                            <Input placeholder="Lieu du sinistre" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                        <Form.Item name="entiteConstat" label="Entité de constat">
                            <Select
                                showSearch
                                placeholder="Sélectionnez l'entité"
                                optionFilterProp="label"
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} md={12} lg={6}>
                        <Form.Item name="provenanceAssure" label="Provenance">
                            <Input placeholder="Provenance de l'assuré" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                        <Form.Item name="destinationAssure" label="Destination">
                            <Input placeholder="Destination de l'assuré" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                        <Form.Item name="vitesseAssure" label="Vitesse (km/h)">
                            <Input type="number" placeholder="Vitesse" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                        <Form.Item name="typeDommageAssure" label="Type de dommage">
                            <Select
                                placeholder="Sélectionnez"
                                allowClear
                                options={OPTIONS.typeDommages}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item name="circonstance" label="Circonstances">
                    <Input.TextArea rows={4} placeholder="Décrivez les circonstances de l'accident" />
                </Form.Item>

                <Form.Item name="observationAgent" label="Observation de l'agent">
                    <Input.TextArea rows={3} placeholder="Observations complémentaires" />
                </Form.Item>

                <Divider orientation="left">Témoignage</Divider>
                <Form.Item name="temoignage" label="Y a-t-il un témoin ?">
                    <Radio.Group>
                        <Radio value="non">Non</Radio>
                        <Radio value="oui">Oui</Radio>
                    </Radio.Group>
                </Form.Item>


                {form.getFieldValue("temoignage") === "oui" && (
                    <>
                        <Row gutter={16}>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item name="nomTemoin" label="Nom du témoin">
                                    <Input placeholder='Le nom du temoin' />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item name="prenomTemoin" label="Prénoms du témoin">
                                    <Input placeholder='Prenom du temoin' />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item name="telephoneTemoin" label="Téléphone du témoin">
                                    <Input placeholder='Telephone' />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} md={12} lg={12}>
                                <Form.Item name="adresseTemoin" label="Adresse du témoin">
                                    <Input placeholder="L'adresse du temoin" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={12}>
                                <Form.Item name="fonctionTemoin" label="Qualité / Fonction du témoin">
                                    <Input
                                        placeholder="Qualité / Fonction du temoin" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </>
                )}

                <Divider orientation="left">Informations du conducteur</Divider>
                <Form.Item name="conduisait" label="L'assuré conduisait-il ?">
                    <Radio.Group>
                        <Radio value="oui">Oui</Radio>
                        <Radio value="non">Non</Radio>
                    </Radio.Group>
                </Form.Item>

                <Row gutter={16}>
                    <Col xs={24} md={12} lg={8}>
                        <Form.Item name="numeroPermis" label="Numéro du permis">
                            <Input placeholder="Numéro de permis" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} lg={8}>
                        <Form.Item name="categoriePermis" label="Catégorie du permis">
                            <Select
                                placeholder="Sélectionnez"
                                options={OPTIONS.permisCategories}
                                allowClear
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} lg={8}>
                        <Form.Item name="dateDelivrancePermis" label="Date de délivrance">
                            <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
                        </Form.Item>
                    </Col>
                </Row>
                {form.getFieldValue("conduisait") === "non" && (
                    <>
                        <Row gutter={16}>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item name="nomConducteur" label="Nom du conducteur">
                                    <Input placeholder="Le nom du conducteur" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item name="prenomConducteur" label="Prénoms du conducteur">
                                    <Input placeholder="Prenom du conducteur" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item name="telephoneConducteur" label="Téléphone du conducteur">
                                    <Input placeholder="Telephone" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} md={12} lg={8}>
                                <Form.Item name="conducteurQualite" label="Qualité du conducteur">
                                    <Select
                                        placeholder="Sélectionnez"
                                        allowClear
                                        options={conducteurQualiteOptions}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </>
                )}
            </Form>
        </Modal>
    );
};

EditModal.propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func,
    sinistre: PropTypes.object,
    onSave: PropTypes.func,
    loading: PropTypes.bool
};